import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl, BaseUrls } from '@app/app.constants';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { ProductOptionWithSubrole } from '@app/core/interfaces/product-option-with-subrole';
import { portalError } from '@app/utils/error/portal-error';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductOptionRepository {
  constructor(
    private authenticationService: AuthenticationService,
    private http: HttpClient
  ) {}

  listProductOptions(): Observable<ProductOptionWithSubrole[]> {
    let url: string;

    if (this.authenticationService.userIsEnterpriseAdmin()) {
      url = BaseUrls.Enterprise.Enterprise + '/productOptions';
    } else if (
      this.authenticationService.userIsServiceProviderAdmin() ||
      this.authenticationService.userIsSystemAdmin()
    ) {
      url = BaseUrls.ServiceProvider.ServiceProvider + '/productOptions';
    } else {
      throw portalError({
        cause: new Error('End-user is not allowed to list product options'),
        id: 'product-option-repository:list-product-options',
      });
    }

    return this.http
      .get<ProductOptionWithSubrole[]>(apiUrl(url))
      .pipe(wrapError('product-option-repository:list'));
  }
}
